import React, { useEffect, useState, useCallback } from "react";
import api from "../api/axios";

function InvitacionesPendientes() {
  const [invitaciones, setInvitaciones] = useState([]);
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchInv = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/salas/invitaciones/pendientes");
      setInvitaciones(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error cargando invitaciones:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchInv();
  }, [fetchInv]);

  const responder = async (id, accion) => {
    try {
      await api.post(`/salas/invitaciones/${id}/${accion}`);
      setMsg(`Invitación ${accion} correctamente.`);
      setInvitaciones((prev) => prev.filter((i) => i.id !== id));
    } catch {
      setMsg("Error al procesar la invitación.");
    }
  };

  if (loading && invitaciones.length === 0) return null;

  return (
    <div className="p-4 bg-white rounded-xl shadow-md mt-6 mb-6">
      <h3 className="font-bold mb-2">Invitaciones pendientes</h3>
      {msg && <div className="text-xs text-blue-600 mb-2">{msg}</div>}
      {invitaciones.length === 0 ? (
          <div className="text-gray-500 text-sm">No tienes invitaciones pendientes.</div>
      ) : (
          <ul className="divide-y">
            {invitaciones.map((inv) => (
              <li key={inv.id} className="py-2 flex justify-between items-center">
                <span>
                  Sala: <b>{inv.nombre_sala}</b>{" "}
                    <span className="text-[10px] opacity-60">
                        ({new Date(inv.fecha).toLocaleDateString()})
                    </span>
                </span>
                <div className="flex gap-2">
                  <button
                    onClick={() => responder(inv.id, "aceptar")}
                    className="bg-green-600 text-white rounded px-3 py-1 text-xs hover:bg-green-700"
                  >
                    Aceptar
                  </button>
                  <button
                    onClick={() => responder(inv.id, "rechazar")}
                    className="bg-red-600 text-white rounded px-3 py-1 text-xs hover:bg-red-700"
                  >
                    Rechazar
                  </button>
                </div>
              </li>
            ))}
          </ul>
      )}
    </div>
  );
}

export default InvitacionesPendientes;
